// import React, { useEffect, useMemo, useState } from "react";
// import { useNavigate, useParams } from "react-router-dom";
// import api from "../services/api";
// import "./ShowtimePage.css";

// // Category navigation items
// const CATEGORY_TABS = [
//   { label: "For you", icon: "for-you" },
//   { label: "Dining", icon: "dining" },
//   { label: "Movies", icon: "movies", isActive: true },
//   { label: "Events", icon: "events" },
//   { label: "Stores", icon: "stores" },
//   { label: "Activities", icon: "activities" },
// ];

// // Filter chip options
// const FILTER_CHIPS = [
//   "Hindi",
//   "3D",
//   "4DX-2D",
//   "After 5 PM",
//   "Recliners",
//   "Wheelchair Friendly",
// ];

// const getTodayIso = () => new Date().toISOString().split("T")[0];

// const toIsoDate = (dateValue) => {
//   if (!dateValue) return "";
//   const parsed = new Date(dateValue);
//   if (Number.isNaN(parsed.getTime())) return "";
//   return parsed.toISOString().split("T")[0];
// };

// // Utility: Build date metadata (day, weekday)
// const buildDateMeta = (isoDate) => {
//   const parsed = new Date(`${isoDate}T00:00:00`);
//   return {
//     full: isoDate,
//     day: parsed.getDate(),
//     weekday: parsed.toLocaleDateString("en-US", { weekday: "short" }),
//     month: parsed.toLocaleDateString("en-US", { month: "short" }),
//   };
// };

// // Utility: Fallback dates (next 8 days)
// const fallbackDates = () => {
//   const dates = [];
//   const now = new Date();
//   for (let index = 0; index < 8; index += 1) {
//     const next = new Date(now);
//     next.setDate(now.getDate() + index);
//     const iso = next.toISOString().split("T")[0];
//     dates.push(buildDateMeta(iso));
//   }
//   return dates;
// };

// // Utility: Format time to 12-hour format
// const formatTime = (timeValue) => {
//   if (!timeValue) return "Time TBA";
//   if (
//     typeof timeValue === "string" &&
//     (timeValue.includes("AM") || timeValue.includes("PM"))
//   ) {
//     return timeValue;
//   }

//   const [hourPart, minutePart = "00"] = String(timeValue).split(":");
//   const parsedHour = Number.parseInt(hourPart, 10);

//   if (Number.isNaN(parsedHour)) return timeValue;

//   const period = parsedHour >= 12 ? "PM" : "AM";
//   const displayHour = parsedHour % 12 || 12;
//   return `${displayHour}:${minutePart} ${period}`;
// };

// // Utility: Format movie duration
// const formatDuration = (minutesValue) => {
//   const minutes = Number(minutesValue);
//   if (!minutes || Number.isNaN(minutes)) return "Runtime TBA";
//   const hours = Math.floor(minutes / 60);
//   const remainder = minutes % 60;
//   if (!hours) return `${remainder} min`;
//   if (!remainder) return `${hours} hr`;
//   return `${hours} hr ${remainder} min`;
// };

// // Utility: Get seat fill status for color coding
// const getSeatStatus = (show) => {
//   const totalSeats = Number(show.totalSeats);
//   const availableSeats = Number(show.availableSeats);
//   if (!totalSeats || Number.isNaN(totalSeats) || Number.isNaN(availableSeats))
//     return "available";
//   const filledRatio = 1 - Math.max(availableSeats, 0) / totalSeats;
//   if (filledRatio >= 0.8) return "almost";
//   if (filledRatio >= 0.55) return "filling";
//   return "available";
// };

// // Utility: Extract month label
// const monthLabel = (isoDate) => {
//   if (!isoDate) return "APR";
//   return new Date(`${isoDate}T00:00:00`)
//     .toLocaleDateString("en-US", { month: "short" })
//     .toUpperCase();
// };

// const ShowtimePage = () => {
//   const navigate = useNavigate();
//   const { movieId } = useParams();

//   const [movie, setMovie] = useState(null);
//   const [theaters, setTheaters] = useState([]);
//   const [selectedDate, setSelectedDate] = useState("");
//   const [loading, setLoading] = useState(true);
//   const [errorMessage, setErrorMessage] = useState("");
//   const [selectedFilters, setSelectedFilters] = useState([]);
//   const [showTrailerModal, setShowTrailerModal] = useState(false);

//   // Filter shows based on selected filters
//   const applyFilters = (shows) => {
//     if (selectedFilters.length === 0) return shows;

//     return shows.filter((show) => {
//       return selectedFilters.every((filter) => {
//         if (filter === "3D" || filter === "4DX-2D") {
//           return show.screenType === filter;
//         }
//         if (filter === "Hindi") {
//           return (show.language || "").includes("Hindi");
//         }
//         if (filter === "After 5 PM") {
//           const hour = Number.parseInt(show.showTime?.split(":")[0] || "0", 10);
//           return hour >= 17;
//         }
//         if (filter === "Recliners") {
//           return show.hasRecliners === true;
//         }
//         if (filter === "Wheelchair Friendly") {
//           return show.wheelchairAccessible === true;
//         }
//         return true;
//       });
//     });
//   };

//   const toggleFilter = (filter) => {
//     setSelectedFilters((prev) =>
//       prev.includes(filter)
//         ? prev.filter((f) => f !== filter)
//         : [...prev, filter],
//     );
//   };

//   // Fetch movie and shows data
//   useEffect(() => {
//     const fetchMovieAndShows = async () => {
//       try {
//         setLoading(true);
//         setErrorMessage("");

//         const [movieRes, showsRes] = await Promise.all([
//           api.get(`/movies/${movieId}`),
//           api.get(`/shows/movie/${movieId}`),
//         ]);

//         const movieData = movieRes?.data || null;
//         const showsData = Array.isArray(showsRes?.data) ? showsRes.data : [];

//         // Group shows by theater
//         const groupedByTheater = {};
//         showsData.forEach((show) => {
//           const theaterId = show.theater?._id;
//           if (!theaterId) return;

//           if (!groupedByTheater[theaterId]) {
//             groupedByTheater[theaterId] = {
//               theater: show.theater,
//               shows: [],
//             };
//           }
//           groupedByTheater[theaterId].shows.push(show);
//         });

//         // Convert to array and sort shows by date/time
//         const groupedTheaters = Object.values(groupedByTheater).map(
//           (entry) => ({
//             ...entry,
//             shows: [...entry.shows].sort((a, b) => {
//               const aKey = `${toIsoDate(a.showDate)}-${a.showTime || "00:00"}`;
//               const bKey = `${toIsoDate(b.showDate)}-${b.showTime || "00:00"}`;
//               return aKey.localeCompare(bKey);
//             }),
//           }),
//         );

//         // Extract unique dates and sort them
//         const showDates = new Set();
//         showsData.forEach((show) => {
//           const iso = toIsoDate(show.showDate);
//           if (iso) showDates.add(iso);
//         });

//         const sortedDates = [...showDates].sort();

//         setMovie(movieData);
//         setTheaters(groupedTheaters);
//         setSelectedDate(sortedDates[0] || getTodayIso());
//       } catch (error) {
//         setErrorMessage(
//           error.response?.data?.message || "Unable to load showtimes.",
//         );
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchMovieAndShows();
//   }, [movieId]);

//   // Build date rail for date picker
//   const dateRail = useMemo(() => {
//     const dateMap = new Map();

//     theaters.forEach((theaterEntry) => {
//       theaterEntry.shows.forEach((show) => {
//         const iso = toIsoDate(show.showDate);
//         if (iso && !dateMap.has(iso)) {
//           dateMap.set(iso, buildDateMeta(iso));
//         }
//       });
//     });

//     const sorted = Array.from(dateMap.values()).sort((a, b) =>
//       a.full.localeCompare(b.full),
//     );
//     return sorted.length ? sorted : fallbackDates();
//   }, [theaters]);

//   // Filter theaters by selected date
//   const theatersForDate = useMemo(() => {
//     return theaters
//       .map((entry) => ({
//         ...entry,
//         shows: applyFilters(
//           entry.shows.filter(
//             (show) => toIsoDate(show.showDate) === selectedDate,
//           ),
//         ),
//       }))
//       .filter((entry) => entry.shows.length > 0);
//   }, [selectedDate, theaters, selectedFilters]);

//   const cityLabel =
//     theaters[0]?.theater?.city ||
//     theaters[0]?.theater?.address?.city ||
//     movie?.city ||
//     "Ahmedabad";

//   const runtimeText = formatDuration(movie?.duration || movie?.runtime);
//   const movieCert = movie?.certification || movie?.censorRating || "UA";
//   const movieLang = movie?.language || "Hindi +1 more";
//   const activeMonth = monthLabel(selectedDate || dateRail[0]?.full);

//   if (loading) {
//     return (
//       <div className="district-page-state">
//         <div className="district-spinner" />
//         <p>Loading showtimes...</p>
//       </div>
//     );
//   }

//   if (!movie) {
//     return (
//       <div className="district-page-state">
//         <h3>Movie not found</h3>
//         <p>{errorMessage || "Unable to find movie."}</p>
//         <button
//           type="button"
//           className="district-primary-btn"
//           onClick={() => navigate("/movies")}
//         >
//           Back to Movies
//         </button>
//       </div>
//     );
//   }

//   return (
//     <div className="district-showtime-page">
//       <main className="district-shell">
//         {/* Fixed Header with Sticky Category Rail */}
//         <header className="district-header">
//           <div className="district-topbar">
//             <div className="district-brand-block">
//               <button
//                 type="button"
//                 className="district-logo-btn"
//                 onClick={() => navigate("/")}
//               >
//                 <span className="district-logo-pill">BookMyCinema</span>
//               </button>
//               <span className="district-divider" />
//               <button type="button" className="district-location-btn">
//                 <svg
//                   width="20"
//                   height="20"
//                   viewBox="0 0 24 24"
//                   fill="none"
//                   stroke="currentColor"
//                   strokeWidth="2"
//                 >
//                   <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" />
//                   <circle cx="12" cy="10" r="3" />
//                 </svg>
//                 <span className="district-location-text">
//                   <strong>Sola</strong>
//                   <small>{cityLabel}</small>
//                 </span>
//               </button>
//             </div>
//             <div className="district-top-actions">
//               <button
//                 type="button"
//                 className="district-icon-btn"
//                 aria-label="Search"
//               >
//                 <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
//                   <path
//                     d="M12.7936 12.7881L17 17M14.7712 7.89465C14.7712 11.7025 11.6884 14.7893 7.88561 14.7893C4.08277 14.7893 0.999969 11.7025 0.999969 7.89465C0.999969 4.08684 4.08277 1 7.88561 1C11.6884 1 14.7712 4.08684 14.7712 7.89465Z"
//                     stroke="currentColor"
//                     strokeWidth="2"
//                     strokeLinecap="round"
//                   />
//                 </svg>
//               </button>
//               <button
//                 type="button"
//                 className="district-avatar-btn"
//                 aria-label="User"
//               >
//                 U
//               </button>
//             </div>
//           </div>

//           <nav className="district-category-rail">
//             {CATEGORY_TABS.map((tab) => (
//               <button
//                 key={tab.label}
//                 type="button"
//                 className={`district-category-chip ${tab.isActive ? "active" : ""}`}
//               >
//                 {tab.label}
//               </button>
//             ))}
//           </nav>
//         </header>

//         <div className="district-content">
//           {/* Movie Hero Section */}
//           <section className="district-movie-hero">
//             <div
//               className="district-poster-wrap"
//               onClick={() => movie?.trailerUrl && setShowTrailerModal(true)}
//             >
//               <img
//                 src={movie.poster || "https://via.placeholder.com/240x320"}
//                 alt={movie.title}
//                 className="district-movie-poster"
//               />
//               {movie?.trailerUrl && (
//                 <span
//                   className="district-play-badge"
//                   role="button"
//                   tabIndex="0"
//                 >
//                   ▶
//                 </span>
//               )}
//             </div>
//             <div className="district-movie-copy">
//               <h1>{movie.title}</h1>
//               <div className="district-meta-line">
//                 <span>{movieCert}</span>
//                 <span>{movieLang}</span>
//                 <span>{runtimeText}</span>
//               </div>
//               <button
//                 type="button"
//                 className="district-outline-btn"
//                 onClick={() => setShowTrailerModal(true)}
//               >
//                 View details
//               </button>
//             </div>
//           </section>

//           {/* Sticky Toolbar with Date Strip and Filters */}
//           <section className="district-toolbar">
//             <div className="district-date-strip">
//               <div className="district-month-pill">{activeMonth}</div>
//               <div className="district-date-scroll">
//                 {dateRail.map((dateItem) => (
//                   <button
//                     key={dateItem.full}
//                     type="button"
//                     className={`district-date-btn ${selectedDate === dateItem.full ? "active" : ""}`}
//                     onClick={() => setSelectedDate(dateItem.full)}
//                   >
//                     <strong>{dateItem.day}</strong>
//                     <small>{dateItem.weekday}</small>
//                   </button>
//                 ))}
//               </div>
//             </div>

//             <div className="district-filter-strip">
//               <span className="district-filter-label">Filters:</span>
//               {FILTER_CHIPS.map((chip) => (
//                 <button
//                   key={chip}
//                   type="button"
//                   className={`district-filter-chip ${selectedFilters.includes(chip) ? "active" : ""}`}
//                   onClick={() => toggleFilter(chip)}
//                 >
//                   {chip}
//                 </button>
//               ))}
//             </div>
//           </section>

//           {/* Legend */}
//           <div className="district-legend">
//             <div className="district-legend-item">
//               <span className="district-dot available" />
//               <span>Available</span>
//             </div>
//             <div className="district-legend-item">
//               <span className="district-dot filling" />
//               <span>Filling fast</span>
//             </div>
//             <div className="district-legend-item">
//               <span className="district-dot almost" />
//               <span>Almost full</span>
//             </div>
//           </div>

//           {/* Theater List */}
//           <section className="district-theater-list">
//             {theatersForDate.length === 0 ? (
//               <div className="district-empty-state">No shows for this date</div>
//             ) : (
//               theatersForDate.map((entry) => {
//                 const theater = entry.theater || {};
//                 const location =
//                   theater.location || theater.address?.area || "Ahmedabad";

//                 return (
//                   <article className="district-theater-card" key={theater._id}>
//                     <div className="district-theater-header">
//                       <div className="district-theater-avatar">
//                         {(theater.name || "T")[0].toUpperCase()}
//                       </div>
//                       <div className="district-theater-copy">
//                         <h3>{theater.name}</h3>
//                         <p>
//                           <span>{location}</span> •<span> Non-cancellable</span>
//                         </p>
//                       </div>
//                       <button type="button" className="district-like-btn">
//                         ♡
//                       </button>
//                     </div>

//                     <div className="district-showtime-grid">
//                       {entry.shows.map((show) => {
//                         const status = getSeatStatus(show);
//                         const format = show.screenType || "3D";
//                         return (
//                           <div
//                             className="district-showtime-item"
//                             key={show._id}
//                           >
//                             <button
//                               type="button"
//                               className={`district-showtime-slot ${status}`}
//                               onClick={() => navigate(`/booking/${show._id}`)}
//                             >
//                               {formatTime(show.showTime)}
//                               {show.soundSystem && (
//                                 <span className="district-slot-sub">
//                                   {show.soundSystem}
//                                 </span>
//                               )}
//                             </button>
//                             <span className="district-slot-label">
//                               {format}
//                             </span>
//                           </div>
//                         );
//                       })}
//                     </div>
//                   </article>
//                 );
//               })
//             )}
//           </section>
//         </div>
//       </main>

//       {/* Trailer Modal */}
//       {showTrailerModal && (
//         <div
//           className="district-modal-overlay"
//           onClick={() => setShowTrailerModal(false)}
//         >
//           <div
//             className="district-modal-content"
//             onClick={(e) => e.stopPropagation()}
//           >
//             <button
//               type="button"
//               className="district-modal-close"
//               onClick={() => setShowTrailerModal(false)}
//               aria-label="Close trailer"
//             >
//               ✕
//             </button>
//             <h2 className="district-modal-title">{movie?.title}</h2>
//             {movie?.trailerUrl ? (
//               <iframe
//                 title="Movie Trailer"
//                 className="district-trailer-iframe"
//                 src={movie.trailerUrl}
//                 frameBorder="0"
//                 allowFullScreen
//               />
//             ) : (
//               <div className="district-trailer-placeholder">
//                 <p>Trailer not available</p>
//               </div>
//             )}
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default ShowtimePage;

import React, { useEffect, useMemo, useState, useCallback } from "react";
import { useNavigate, useParams } from "react-router-dom";
import api from "../services/api";
import BrandLogo from "../components/common/BrandLogo";
import "./ShowtimePage.css";

// Category navigation items
const CATEGORY_TABS = [
  { label: "For you", icon: "for-you" },
  { label: "Dining", icon: "dining" },
  { label: "Movies", icon: "movies", isActive: true },
  { label: "Events", icon: "events" },
  { label: "Stores", icon: "stores" },
  { label: "Activities", icon: "activities" },
];

// Filter chip options
const FILTER_CHIPS = [
  "Hindi",
  "3D",
  "4DX-2D",
  "After 5 PM",
  "Recliners",
  "Wheelchair Friendly",
];

const getTodayIso = () => new Date().toISOString().split("T")[0];

const toIsoDate = (dateValue) => {
  if (!dateValue) return "";
  const parsed = new Date(dateValue);
  if (Number.isNaN(parsed.getTime())) return "";
  return parsed.toISOString().split("T")[0];
};

// Utility: Build date metadata (day, weekday)
const buildDateMeta = (isoDate) => {
  const parsed = new Date(`${isoDate}T00:00:00`);
  return {
    full: isoDate,
    day: parsed.getDate(),
    weekday: parsed.toLocaleDateString("en-US", { weekday: "short" }),
    month: parsed.toLocaleDateString("en-US", { month: "short" }),
  };
};

// Utility: Fallback dates (next 8 days)
const fallbackDates = () => {
  const dates = [];
  const now = new Date();
  for (let index = 0; index < 8; index += 1) {
    const next = new Date(now);
    next.setDate(now.getDate() + index);
    const iso = next.toISOString().split("T")[0];
    dates.push(buildDateMeta(iso));
  }
  return dates;
};

// Utility: Format time to 12-hour format
const formatTime = (timeValue) => {
  if (!timeValue) return "Time TBA";
  if (
    typeof timeValue === "string" &&
    (timeValue.includes("AM") || timeValue.includes("PM"))
  ) {
    return timeValue;
  }

  const [hourPart, minutePart = "00"] = String(timeValue).split(":");
  const parsedHour = Number.parseInt(hourPart, 10);

  if (Number.isNaN(parsedHour)) return timeValue;

  const period = parsedHour >= 12 ? "PM" : "AM";
  const displayHour = parsedHour % 12 || 12;
  return `${displayHour}:${minutePart} ${period}`;
};

// Utility: Format movie duration
const formatDuration = (minutesValue) => {
  const minutes = Number(minutesValue);
  if (!minutes || Number.isNaN(minutes)) return "Runtime TBA";
  const hours = Math.floor(minutes / 60);
  const remainder = minutes % 60;
  if (!hours) return `${remainder} min`;
  if (!remainder) return `${hours} hr`;
  return `${hours} hr ${remainder} min`;
};

// Utility: Get seat fill status for color coding
const getSeatStatus = (show) => {
  const totalSeats = Number(show.totalSeats);
  const availableSeats = Number(show.availableSeats);
  if (!totalSeats || Number.isNaN(totalSeats) || Number.isNaN(availableSeats))
    return "available";
  const filledRatio = 1 - Math.max(availableSeats, 0) / totalSeats;
  if (filledRatio >= 0.8) return "almost";
  if (filledRatio >= 0.55) return "filling";
  return "available";
};

// Utility: Extract month label
const monthLabel = (isoDate) => {
  if (!isoDate) return "APR";
  return new Date(`${isoDate}T00:00:00`)
    .toLocaleDateString("en-US", { month: "short" })
    .toUpperCase();
};

const ShowtimePage = () => {
  const navigate = useNavigate();
  const { movieId } = useParams();

  const [movie, setMovie] = useState(null);
  const [theaters, setTheaters] = useState([]);
  const [selectedDate, setSelectedDate] = useState("");
  const [loading, setLoading] = useState(true);
  const [errorMessage, setErrorMessage] = useState("");
  const [selectedFilters, setSelectedFilters] = useState([]);
  const [showTrailerModal, setShowTrailerModal] = useState(false);

  // Filter shows based on selected filters
  const applyFilters = (shows) => {
    if (selectedFilters.length === 0) return shows;

    return shows.filter((show) => {
      return selectedFilters.every((filter) => {
        if (filter === "3D" || filter === "4DX-2D") {
          return show.screenType === filter;
        }
        if (filter === "Hindi") {
          return (show.language || "").includes("Hindi");
        }
        if (filter === "After 5 PM") {
          const hour = Number.parseInt(show.showTime?.split(":")[0] || "0", 10);
          return hour >= 17;
        }
        if (filter === "Recliners") {
          return show.hasRecliners === true;
        }
        if (filter === "Wheelchair Friendly") {
          return show.wheelchairAccessible === true;
        }
        return true;
      });
    });
  };

  const toggleFilter = (filter) => {
    setSelectedFilters((prev) =>
      prev.includes(filter)
        ? prev.filter((f) => f !== filter)
        : [...prev, filter],
    );
  };

  const fetchMovieAndShows = useCallback(async (isSync = false) => {
    try {
      if (!isSync) setLoading(true);
      setErrorMessage("");

      const [movieRes, showsRes] = await Promise.all([
        api.get(`/movies/${movieId}`),
        api.get(`/shows/movie/${movieId}`),
      ]);

      const movieData = movieRes?.data || null;
      const showsData = Array.isArray(showsRes?.data) ? showsRes.data : [];

      // Group shows by theater
      const groupedByTheater = {};
      showsData.forEach((show) => {
        const theaterId = show.theater?._id || show.theater;
        if (!theaterId) return;

        if (!groupedByTheater[theaterId]) {
          groupedByTheater[theaterId] = {
            theater: typeof show.theater === 'string' ? { _id: show.theater, name: 'Cinema' } : show.theater,
            shows: [],
          };
        }
        groupedByTheater[theaterId].shows.push(show);
      });

      // Convert to array and sort shows by date/time
      const groupedTheaters = Object.values(groupedByTheater).map(
        (entry) => ({
          ...entry,
          shows: [...entry.shows].sort((a, b) => {
            const aKey = `${toIsoDate(a.showDate)}-${a.showTime || "00:00"}`;
            const bKey = `${toIsoDate(b.showDate)}-${b.showTime || "00:00"}`;
            return aKey.localeCompare(bKey);
          }),
        }),
      );

      // Extract unique dates and sort them
      const showDates = new Set();
      showsData.forEach((show) => {
        const iso = toIsoDate(show.showDate);
        if (iso) showDates.add(iso);
      });

      const sortedDates = [...showDates].sort();

      setMovie(movieData);
      setTheaters(groupedTheaters);
      setSelectedDate((prevDate) => prevDate || sortedDates[0] || getTodayIso());
    } catch (error) {
      setErrorMessage(
        error.response?.data?.message || "Unable to load showtimes.",
      );
    } finally {
      setLoading(false);
    }
  }, [movieId]);

  useEffect(() => {
    fetchMovieAndShows();

    // Real-time update listeners
    const handleUpdate = () => {
      console.log("🔄 Silent real-time update on ShowtimePage...");
      fetchMovieAndShows(true);
    };

    window.addEventListener("shows-updated", handleUpdate);
    window.addEventListener("movies-updated", handleUpdate);
    window.addEventListener("show-added", handleUpdate);
    window.addEventListener("show-updated", handleUpdate);
    window.addEventListener("show-deleted", handleUpdate);

    return () => {
      window.removeEventListener("shows-updated", handleUpdate);
      window.removeEventListener("movies-updated", handleUpdate);
      window.removeEventListener("show-added", handleUpdate);
      window.removeEventListener("show-updated", handleUpdate);
      window.removeEventListener("show-deleted", handleUpdate);
    };
  }, [fetchMovieAndShows]);

  // Build date rail for date picker
  const dateRail = useMemo(() => {
    const dateMap = new Map();

    theaters.forEach((theaterEntry) => {
      theaterEntry.shows.forEach((show) => {
        const iso = toIsoDate(show.showDate);
        if (iso && !dateMap.has(iso)) {
          dateMap.set(iso, buildDateMeta(iso));
        }
      });
    });

    const sorted = Array.from(dateMap.values()).sort((a, b) =>
      a.full.localeCompare(b.full),
    );
    return sorted.length ? sorted : fallbackDates();
  }, [theaters]);

  // Filter theaters by selected date
  const theatersForDate = useMemo(() => {
    return theaters
      .map((entry) => ({
        ...entry,
        shows: applyFilters(
          entry.shows.filter(
            (show) => toIsoDate(show.showDate) === selectedDate,
          ),
        ),
      }))
      .filter((entry) => entry.shows.length > 0);
  }, [selectedDate, theaters, selectedFilters]);

  const cityLabel =
    theaters[0]?.theater?.city ||
    theaters[0]?.theater?.address?.city ||
    movie?.city ||
    "Ahmedabad";

  const runtimeText = formatDuration(movie?.duration || movie?.runtime);
  const movieCert = movie?.certification || movie?.censorRating || "UA7+";
  const movieLang = movie?.language || "Hindi +1 more";
  const activeMonth = monthLabel(selectedDate || dateRail[0]?.full);

  if (loading) {
    return (
      <div className="district-page-state">
        <div className="district-spinner" />
        <p>Loading showtimes...</p>
      </div>
    );
  }

  if (!movie) {
    return (
      <div className="district-page-state">
        <h3>Movie not found</h3>
        <p>{errorMessage || "Unable to find movie."}</p>
        <button
          type="button"
          className="district-primary-btn"
          onClick={() => navigate("/movies")}
        >
          Back to Movies
        </button>
      </div>
    );
  }

  return (
    <div className="district-showtime-page">
      <main className="district-shell">
        {/* Fixed Header with Sticky Category Rail */}
        <header className="district-header">
          <div className="district-topbar">
            <div className="district-brand-block">
              <button
                type="button"
                className="district-logo-btn"
                onClick={() => navigate("/")}
              >
                <BrandLogo />
              </button>
              <span className="district-divider" />
              <button type="button" className="district-location-btn">
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                >
                  <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" />
                  <circle cx="12" cy="10" r="3" />
                </svg>
                <span className="district-location-text">
                  <strong>Sola</strong>
                  <small>{cityLabel}</small>
                </span>
              </button>
            </div>
            <div className="district-top-actions">
              <button
                type="button"
                className="district-icon-btn"
                aria-label="Search"
              >
                <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
                  <path
                    d="M12.7936 12.7881L17 17M14.7712 7.89465C14.7712 11.7025 11.6884 14.7893 7.88561 14.7893C4.08277 14.7893 0.999969 11.7025 0.999969 7.89465C0.999969 4.08684 4.08277 1 7.88561 1C11.6884 1 14.7712 4.08684 14.7712 7.89465Z"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                  />
                </svg>
              </button>
              <button
                type="button"
                className="district-avatar-btn"
                aria-label="User"
              >
                U
              </button>
            </div>
          </div>

          <nav className="district-category-rail">
            {CATEGORY_TABS.map((tab) => (
              <button
                key={tab.label}
                type="button"
                className={`district-category-chip ${tab.isActive ? "active" : ""}`}
              >
                {tab.label}
              </button>
            ))}
          </nav>
        </header>

        <div className="district-content">
          {/* Movie Hero Section */}
          <section className="district-movie-hero">
            <div className="district-movie-copy">
              <h1>{movie.title}</h1>
              <div className="district-meta-line">
                <span>{movieCert}</span>
                <span>{movieLang}</span>
                <span>{runtimeText}</span>
              </div>
              <button
                type="button"
                className="district-outline-btn"
                onClick={() => setShowTrailerModal(true)}
              >
                View details
              </button>
            </div>

            <div
              className="district-poster-wrap"
              onClick={() => setShowTrailerModal(true)}
            >
              <img
                src={movie.poster || "https://via.placeholder.com/240x320"}
                alt={movie.title}
                className="district-movie-poster"
              />
              <span className="district-play-badge" role="button" tabIndex="0">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="black">
                  <polygon points="5 3 19 12 5 21 5 3"></polygon>
                </svg>
              </span>
            </div>
          </section>

          {/* Sticky Toolbar with Date Strip and Filters */}
          <section className="district-toolbar">
            <div className="district-date-strip">
              <div className="district-month-pill">{activeMonth}</div>
              <div className="district-date-scroll">
                {dateRail.map((dateItem) => (
                  <button
                    key={dateItem.full}
                    type="button"
                    className={`district-date-btn ${selectedDate === dateItem.full ? "active" : ""}`}
                    onClick={() => setSelectedDate(dateItem.full)}
                  >
                    <strong>{dateItem.day}</strong>
                    <small>{dateItem.weekday}</small>
                  </button>
                ))}
              </div>
            </div>

            <div className="district-filter-strip">
              <span className="district-filter-label">Filters:</span>
              {FILTER_CHIPS.map((chip) => (
                <button
                  key={chip}
                  type="button"
                  className={`district-filter-chip ${selectedFilters.includes(chip) ? "active" : ""}`}
                  onClick={() => toggleFilter(chip)}
                >
                  {chip} {selectedFilters.includes(chip) && "×"}
                </button>
              ))}
            </div>
          </section>

          {/* Legend */}
          <div className="district-legend">
            <div className="district-legend-item">
              <span className="district-dot available" />
              <span>Available</span>
            </div>
            <div className="district-legend-item">
              <span className="district-dot filling" />
              <span>Filling fast</span>
            </div>
            <div className="district-legend-item">
              <span className="district-dot almost" />
              <span>Almost full</span>
            </div>
          </div>

          {/* Theater List */}
          <section className="district-theater-list">
            {theatersForDate.length === 0 ? (
              <div className="district-empty-state">No shows for this date</div>
            ) : (
              theatersForDate.map((entry) => {
                const theater = entry.theater || {};
                const location =
                  theater.location || theater.address?.area || "Ahmedabad";

                return (
                  <article className="district-theater-card" key={theater._id}>
                    <div className="district-theater-header">
                      <div className="district-theater-avatar">
                        {(theater.name || "T")[0].toUpperCase()}
                      </div>
                      <div className="district-theater-copy">
                        <h3>{theater.name}</h3>
                        <p>
                          <span>{location}</span> •<span> Non-cancellable</span>
                        </p>
                      </div>
                      <button type="button" className="district-like-btn">
                        ♡
                      </button>
                    </div>

                    <div className="district-showtime-grid">
                      {entry.shows.map((show) => {
                        const status = getSeatStatus(show);
                        const format = show.screenType || "3D";
                        return (
                          <div
                            className="district-showtime-item"
                            key={show._id}
                          >
                            <button
                              type="button"
                              className={`district-showtime-slot ${status}`}
                              onClick={() => navigate(`/booking/${show._id}`)}
                            >
                              {formatTime(show.showTime)}
                              {show.soundSystem && (
                                <span className="district-slot-sub">
                                  {show.soundSystem}
                                </span>
                              )}
                            </button>
                            <span className="district-slot-label">
                              {format}
                            </span>
                          </div>
                        );
                      })}
                    </div>
                  </article>
                );
              })
            )}
          </section>
        </div>
      </main>

      {/* Trailer Modal */}
      {showTrailerModal && (
        <div
          className="district-modal-overlay"
          onClick={() => setShowTrailerModal(false)}
        >
          <div
            className="district-modal-content"
            onClick={(e) => e.stopPropagation()}
          >
            <button
              type="button"
              className="district-modal-close"
              onClick={() => setShowTrailerModal(false)}
              aria-label="Close trailer"
            >
              ✕
            </button>
            <h2 className="district-modal-title">{movie?.title}</h2>
            {movie?.trailerUrl ? (
              <iframe
                title="Movie Trailer"
                className="district-trailer-iframe"
                src={movie.trailerUrl}
                frameBorder="0"
                allowFullScreen
              />
            ) : (
              <div className="district-trailer-placeholder">
                <p>Trailer not available</p>
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default ShowtimePage;